import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/webhooks-specification',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::index
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/dashboard/webhooks-specification'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const webhooksSpecification = {
    index: Object.assign(index, index),
}

export default webhooksSpecification